import { cn } from "@/common/utils/cn";
import * as SwitchPrimitives from "@radix-ui/react-switch";

interface SwitchProps {
  className?: string;
  thumbClassName?: string;
  Icon?: JSX.Element;
}

const Switch = ({ className, thumbClassName, Icon, ...props }: SwitchProps & SwitchPrimitives.SwitchProps) => {
  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:00ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        className
      )}
      {...props}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none flex items-center justify-center h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          thumbClassName
        )}
      >
        {Icon}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  )
}

export default Switch;
